// extracted by mini-css-extract-plugin
export default {"bg":"NuF6UZ"};